import { render, staticRenderFns } from "./WorkFlowPage.vue?vue&type=template&id=3a003917&scoped=true"
import script from "./WorkFlowPage.vue?vue&type=script&lang=js"
export * from "./WorkFlowPage.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowPage.vue?vue&type=style&index=0&id=3a003917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a003917",
  null
  
)

export default component.exports